export default __webpack_public_path__ + "user-icon.png?c4d64c2b54d61b2a0dd3cbe7ddd67506";